var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginimg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-nursing-home",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-nursing-home:not(.animated) .animable {opacity: 0;}svg#freepik_stories-nursing-home.animated #freepik--Characters--inject-2 {animation: 1.5s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn,6s Infinite  linear heartbeat;animation-delay: 0s,1.5s;}            @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2",
    className: "animable",
    style: {
      transformOrigin: "244.495px 239.372px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.63,45.32S249.05,18.08,173.88,61.44,60.77,190.86,28.2,259.8s-13.83,139.06,43.56,171,96.41-15.16,176.91-17.45,102.15,9.21,169-36.26,78.87-152.88,26.18-232.35S325.63,45.32,325.63,45.32Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "244.495px 239.372px"
    },
    id: "el4t6k7gnzir8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqtfxv7f103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.63,45.32S249.05,18.08,173.88,61.44,60.77,190.86,28.2,259.8s-13.83,139.06,43.56,171,96.41-15.16,176.91-17.45,102.15,9.21,169-36.26,78.87-152.88,26.18-232.35S325.63,45.32,325.63,45.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "244.495px 239.372px"
    },
    className: "animable",
    id: "elrf7t8il7u7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "249.73px 458.41px"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.73,
    y1: 458.41,
    x2: 481.73,
    y2: 458.41,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "249.73px 458.41px"
    },
    id: "el7ttnolyvjxf",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2",
    className: "animable",
    style: {
      transformOrigin: "379.595px 204.835px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 34.47,
    width: 91.4,
    height: 343.51,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "322.7px 206.225px"
    },
    id: "elgl7zdg4jt6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.5,34.47H274.68a1.39,1.39,0,0,1-1.39-1.39h0a1.39,1.39,0,0,1,1.39-1.39H484.5a1.4,1.4,0,0,1,1.4,1.39h0A1.4,1.4,0,0,1,484.5,34.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "379.595px 33.08px"
    },
    id: "eluwfu7e54whj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.26,
    y1: 293.5,
    x2: 480.3,
    y2: 293.5,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "424.28px 293.5px"
    },
    id: "ellcxtmj09dv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.26,
    y1: 286.83,
    x2: 480.3,
    y2: 286.83,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "424.28px 286.83px"
    },
    id: "eln9qhq2xzjnb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.26,
    y1: 157.5,
    x2: 480.3,
    y2: 157.5,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "424.28px 157.5px"
    },
    id: "elxp86zcsou8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.26,
    y1: 163.37,
    x2: 480.3,
    y2: 163.37,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "424.28px 163.37px"
    },
    id: "elenqju3oyiuk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.63,
    y1: 34.98,
    x2: 283.63,
    y2: 61.36,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "283.63px 48.17px"
    },
    id: "elwynvgqvlzb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.91,
    y1: 38.89,
    x2: 287.91,
    y2: 209.14,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "287.91px 124.015px"
    },
    id: "eliz3sx2iez0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.29,
    y1: 34.66,
    x2: 298.29,
    y2: 55.17,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "298.29px 44.915px"
    },
    id: "elx0w8chrll3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.29,
    y1: 60.05,
    x2: 298.29,
    y2: 71.45,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "298.29px 65.75px"
    },
    id: "elkp2bvqhbm3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 359.04,
    y1: 64.61,
    x2: 359.04,
    y2: 69.5,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "359.04px 67.055px"
    },
    id: "el2ksqj2txsj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 359.04,
    y1: 34.98,
    x2: 359.04,
    y2: 60.05,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "359.04px 47.515px"
    },
    id: "elmigghspwss8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.58,
    y1: 89.68,
    x2: 309.58,
    y2: 93.59,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "309.58px 91.635px"
    },
    id: "eliddgscjkges",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.58,
    y1: 39.22,
    x2: 309.58,
    y2: 85.12,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "309.58px 62.17px"
    },
    id: "el475qsxowuvr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.3,
    y1: 38.89,
    x2: 316.3,
    y2: 53.22,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "316.3px 46.055px"
    },
    id: "elyuverisv2om",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.1,
    y1: 38.89,
    x2: 351.1,
    y2: 53.22,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "351.1px 46.055px"
    },
    id: "elpguonvu1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.85,
    y1: 34.66,
    x2: 324.85,
    y2: 157.14,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "324.85px 95.9px"
    },
    id: "elr3usjc8fhfj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.14,
    y1: 35.31,
    x2: 336.14,
    y2: 41.82,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "336.14px 38.565px"
    },
    id: "elsngp9oh4uv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.86,
    y1: 35.31,
    x2: 342.86,
    y2: 122.14,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "342.86px 78.725px"
    },
    id: "el3zenn1xyqtq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.48,
    y1: 40.52,
    x2: 332.48,
    y2: 58.75,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "332.48px 49.635px"
    },
    id: "elr5s1v5mcee9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.9,
    y1: 139.66,
    x2: 387.54,
    y2: 142.6,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "388.72px 141.13px"
    },
    id: "elugewnwtomh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 439.29,
    y1: 80.67,
    x2: 393.71,
    y2: 134.91,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "416.5px 107.79px"
    },
    id: "elrhbphui6wn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.07,
    y1: 112.1,
    x2: 411.55,
    y2: 132.87,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "420.31px 122.485px"
    },
    id: "elegi7c32nn9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.9,
    y1: 268.99,
    x2: 387.54,
    y2: 271.94,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "388.72px 270.465px"
    },
    id: "ell0ybhx6rxs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.02,
    y1: 205.38,
    x2: 393.71,
    y2: 264.24,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "417.365px 234.81px"
    },
    id: "elu6hedffwg0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.07,
    y1: 241.44,
    x2: 411.55,
    y2: 262.2,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "420.31px 251.82px"
    },
    id: "elghmu6affdn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.95,
    y1: 163.42,
    x2: 447.95,
    y2: 285.05,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "447.95px 224.235px"
    },
    id: "el633xzh1o6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.95,
    y1: 33.9,
    x2: 447.95,
    y2: 157.26,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "447.95px 95.58px"
    },
    id: "eltrs35ub0jfm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.01,
    y1: 163.57,
    x2: 454.01,
    y2: 285.05,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "454.01px 224.31px"
    },
    id: "el64mdur6kfg9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.01,
    y1: 33.9,
    x2: 454.01,
    y2: 157.2,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "454.01px 95.55px"
    },
    id: "el0mq60mw1i1bj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-2",
    className: "animable",
    style: {
      transformOrigin: "138.02px 126.645px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.91,
    y: 134.13,
    width: 206.21,
    height: 5.1,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "138.015px 136.68px"
    },
    id: "el4z4e1chxiiu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 182.11,
    width: 247.04,
    height: 5.1,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "138.02px 184.66px"
    },
    id: "elmsozqhtzjy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.67,76.83V134H104V76.83Zm46.39,54.88H57.6V79.11h44.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "79.835px 105.415px"
    },
    id: "el3x2hbpj3ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.68,142.64v39h33v-39Zm31.64,37.44H139V144.19h30.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "154.18px 162.14px"
    },
    id: "elxpymckxuy0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,100v34H143V100Zm25.34,30H117.62V104h21.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "128.6px 117px"
    },
    id: "elkx2knthz3tn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.81,147.6v34H58.57v-34Zm25.34,30H33.23V151.65H55.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "44.19px 164.6px"
    },
    id: "eladvs5kow15g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.56,159.49v22.14H85.28V159.49ZM83.05,179H68.79V162.13H83.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "75.92px 170.56px"
    },
    id: "elctgxuky6dt4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.07,159.49v22.14h18.72V159.49ZM124.56,179H110.3V162.13h14.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "117.43px 170.56px"
    },
    id: "elxz3b07e1kvn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.94,118.77h10.9a2.57,2.57,0,0,1,2.57,2.57V134a0,0,0,0,1,0,0h-16a0,0,0,0,1,0,0V121.35A2.57,2.57,0,0,1,179.94,118.77Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "185.41px 126.385px"
    },
    id: "elt2f6nuryg0o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.55,
    y: 115.18,
    width: 9.68,
    height: 3.48,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "185.39px 116.92px"
    },
    id: "elm65mex7xb3h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.36,115.07a82.05,82.05,0,0,1,5.1-10.54c2.39-3.75,8.17-6.81,11.91-6.81s10.89,4.08,15.66,9.53",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "203.695px 106.395px"
    },
    id: "elq5uwbmp2ub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.63,98.74s2-6.8,8.17-9.53,12.25-1.7,13.27-2.72",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "211.35px 92.615px"
    },
    id: "el89lxuhxhvuy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.16,115a12.94,12.94,0,0,0-2.59-7.71c-2.72-3.4-9.18-4.77-13.27-2a30,30,0,0,0-6.8,6.46",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "172.83px 109.404px"
    },
    id: "el7g9e9k5jbp9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.41,104.19S169,108.61,168,113a21.06,21.06,0,0,0,.34,9.19",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "170.529px 113.19px"
    },
    id: "el3clfhx56g1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.46,104.53c3.52-6.61,2.74-14.36,5.39-21.23,2.74-7.09,8.92-10.92,16.39-11.44",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "203.35px 88.195px"
    },
    id: "el7aj75yny7st",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.08,110.9s-2.8,0-3.73,2.23a9.07,9.07,0,0,0-.56,4.47,5,5,0,0,0,3.54-3C162.45,112,162.08,110.9,162.08,110.9Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "159.928px 114.25px"
    },
    id: "el11bks5038rh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.2,105.81s-1.08-2.58-3.5-2.57a9,9,0,0,0-4.34,1.21,5,5,0,0,0,4.12,2.11C166.31,106.59,167.2,105.81,167.2,105.81Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "163.28px 104.9px"
    },
    id: "eligsi36slz8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.16,116.7s-2.41-1.42-4.35,0a9,9,0,0,0-2.76,3.56,5,5,0,0,0,4.57-.76C166.91,117.85,167.16,116.7,167.16,116.7Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "163.605px 118.289px"
    },
    id: "elnaa5rm9lruk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.2,121.3s-2.11,1.84-1.35,4.13a9.06,9.06,0,0,0,2.52,3.74,5,5,0,0,0,.71-4.57C169.21,121.9,168.2,121.3,168.2,121.3Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "168.515px 125.235px"
    },
    id: "el4emnbfnyig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.09,111.55s-.71,2.7,1.21,4.17a9,9,0,0,0,4.18,1.67,5,5,0,0,0-2-4.18C169.26,111.47,168.09,111.55,168.09,111.55Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "170.722px 114.47px"
    },
    id: "elv2vkkpm3y9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.61,103.55s.84-2.66-1-4.23a9.06,9.06,0,0,0-4.09-1.88,5,5,0,0,0,1.77,4.27C169.43,103.57,170.61,103.55,170.61,103.55Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "168.151px 100.495px"
    },
    id: "elxjlq81mqhr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.62,103.82s2.07-1.87,1.27-4.16A9.09,9.09,0,0,0,174.31,96a5,5,0,0,0-.64,4.58C174.59,103.24,175.62,103.82,175.62,103.82Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "175.227px 99.91px"
    },
    id: "el1mh9boxrn4t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.93,92.64s2.07-1.87,1.27-4.15a9.08,9.08,0,0,0-2.58-3.7,5,5,0,0,0-.63,4.59C202.9,92.06,203.93,92.64,203.93,92.64Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "203.539px 88.715px"
    },
    id: "elikke78rnkcd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.13,88.36s2.07-1.87,1.27-4.16a9.09,9.09,0,0,0-2.58-3.69,5,5,0,0,0-.64,4.58C211.1,87.78,212.13,88.36,212.13,88.36Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "211.737px 84.435px"
    },
    id: "el98hkeufo40h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,87.05s2.07-1.87,1.27-4.15a9.17,9.17,0,0,0-2.58-3.7,5,5,0,0,0-.63,4.59C218,86.47,219,87.05,219,87.05Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "218.609px 83.125px"
    },
    id: "elsthvquedz3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,111.22s2.8-.09,3.66-2.35a9,9,0,0,0,.41-4.49,5,5,0,0,0-3.44,3.09C172.23,110.12,172.63,111.22,172.63,111.22Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "174.686px 107.8px"
    },
    id: "elarc04ljuaz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.71,93.3s.62-2.72-1.35-4.13a9,9,0,0,0-4.23-1.55,5,5,0,0,0,2.11,4.12C216.53,93.41,217.71,93.3,217.71,93.3Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "214.966px 90.4607px"
    },
    id: "elbnec7lgm5nf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.41,93.12s.63-2.73-1.34-4.14a9.05,9.05,0,0,0-4.23-1.55A5,5,0,0,0,221,91.55C223.24,93.23,224.41,93.12,224.41,93.12Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "221.673px 90.2757px"
    },
    id: "elilqtazt26ns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.21,114.38s2.47-1.3,2.25-3.71a9.11,9.11,0,0,0-1.59-4.22,5,5,0,0,0-1.74,4.29C164.36,113.57,165.21,114.38,165.21,114.38Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "165.79px 110.415px"
    },
    id: "elfyv50z1lus4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.71,110.29s2.47-1.31,2.25-3.72a9.11,9.11,0,0,0-1.59-4.22,5,5,0,0,0-1.74,4.29C192.86,109.47,193.71,110.29,193.71,110.29Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "194.29px 106.32px"
    },
    id: "el5lmo3b7r8xt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,101.6s-2,2-1.13,4.2a9,9,0,0,0,2.71,3.6,5,5,0,0,0,.47-4.6C189.39,102.15,188.35,101.6,188.35,101.6Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "188.878px 105.5px"
    },
    id: "el8cnajsc5atd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.61,106.19s2.47-1.31,2.25-3.72a9,9,0,0,0-1.6-4.21,5,5,0,0,0-1.73,4.28C199.75,105.37,200.61,106.19,200.61,106.19Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "201.19px 102.225px"
    },
    id: "elvs2zc3rilb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,106.2s2.06-1.89,1.23-4.17a9.11,9.11,0,0,0-2.62-3.67A5,5,0,0,0,207,103C207.92,105.63,209,106.2,209,106.2Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "208.557px 102.28px"
    },
    id: "el7h7hhv11rit",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.47,109.74s2.06-1.89,1.23-4.17a9.11,9.11,0,0,0-2.62-3.67,5,5,0,0,0-.58,4.59C214.44,109.17,215.47,109.74,215.47,109.74Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "215.042px 105.82px"
    },
    id: "el8pt8hncb3qd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.82,101.71s-1.76-2.16-4.08-1.47a9,9,0,0,0-3.82,2.4,5,5,0,0,0,4.55.85C223.19,102.71,223.82,101.71,223.82,101.71Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "219.87px 101.906px"
    },
    id: "elhivj9d7fm3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.05,77.42s0-2.79-2.25-3.72a9.06,9.06,0,0,0-4.47-.54,5,5,0,0,0,3,3.53C213.93,77.8,215.05,77.42,215.05,77.42Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "211.69px 75.2826px"
    },
    id: "elqyryt73fba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.69,66.08s-2.77.38-3.39,2.72a9,9,0,0,0,.06,4.51,5,5,0,0,0,3.1-3.44C212.21,67.14,211.69,66.08,211.69,66.08Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "209.954px 69.695px"
    },
    id: "el50zkqbhzh6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.41,81.15s0-2.8-2.24-3.72a9,9,0,0,0-4.48-.55,5,5,0,0,0,3,3.53C206.3,81.52,207.41,81.15,207.41,81.15Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "204.05px 79.0059px"
    },
    id: "elos9iokwider",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.05,69.8s-2.77.39-3.39,2.73a9.1,9.1,0,0,0,.06,4.5,5,5,0,0,0,3.1-3.43C204.57,70.86,204.05,69.8,204.05,69.8Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "202.316px 73.415px"
    },
    id: "elhr8ql24zf7n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.56,85.78s-1.73-2.19-4.06-1.53a9,9,0,0,0-3.85,2.33,5,5,0,0,0,4.53.93C203.92,86.77,204.56,85.78,204.56,85.78Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "200.605px 85.9142px"
    },
    id: "elrqj0dvt2aho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9,79s-1.94,2-1,4.23a9.08,9.08,0,0,0,2.83,3.51,5,5,0,0,0,.31-4.62C196,79.46,194.9,79,194.9,79Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "195.553px 82.87px"
    },
    id: "elmeyll3ofkvj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.51,95.28s-1.73-2.19-4.06-1.53a9.09,9.09,0,0,0-3.85,2.33,5,5,0,0,0,4.53.93C201.87,96.27,202.51,95.28,202.51,95.28Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "198.555px 95.4142px"
    },
    id: "elglnafk1wxed",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.85,88.45s-1.94,2-1,4.23a9.08,9.08,0,0,0,2.83,3.51,5,5,0,0,0,.31-4.62C193.92,89,192.85,88.45,192.85,88.45Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "193.503px 92.32px"
    },
    id: "el6ki9nyvyd4q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,97.61s-1.77-2.16-4.09-1.47a9,9,0,0,0-3.82,2.4,5,5,0,0,0,4.55.85C215.37,98.61,216,97.61,216,97.61Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "212.045px 97.8061px"
    },
    id: "elazlwou5lui",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.53,93s-1.77-2.17-4.09-1.47a9.07,9.07,0,0,0-3.82,2.39,5,5,0,0,0,4.55.86C210.9,94,211.53,93,211.53,93Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "207.575px 93.1932px"
    },
    id: "elcnuwl4txg1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,85.69s-1.77-2.16-4.09-1.47a9,9,0,0,0-3.82,2.4,5,5,0,0,0,4.55.85C228.41,86.69,229,85.69,229,85.69Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "225.045px 85.8861px"
    },
    id: "ely8ojmk8a76",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.4,71s-1.77-2.17-4.09-1.48a9.07,9.07,0,0,0-3.81,2.4,5,5,0,0,0,4.54.86C220.77,72,221.4,71,221.4,71Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "217.45px 71.1889px"
    },
    id: "elkvaims3gbyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.43,115s2.06-1.89,1.23-4.16a9,9,0,0,0-2.62-3.67,5,5,0,0,0-.58,4.59C220.4,114.38,221.43,115,221.43,115Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "221.002px 111.085px"
    },
    id: "elvkkj9h3cywl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.13,181.63h10.66c3.61-2.45,6.07-7.32,6.07-12.93a17.14,17.14,0,0,0-2.76-9.53H191.82a17.14,17.14,0,0,0-2.76,9.53C189.06,174.31,191.52,179.18,195.13,181.63Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "200.46px 170.4px"
    },
    id: "elqw72edgirtj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.75,
    y: 144.68,
    width: 6.81,
    height: 37.43,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "226.155px 163.395px"
    },
    id: "el98o1oz0kzo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.23,
    y: 144.68,
    width: 6.81,
    height: 37.43,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "233.635px 163.395px"
    },
    id: "elqm3ij4seh5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.72,
    y: 144.68,
    width: 6.81,
    height: 37.43,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "241.125px 163.395px"
    },
    id: "el4ucv8j8ddex",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2",
    className: "animable",
    style: {
      transformOrigin: "68.9px 347.805px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.93,354.1a26.68,26.68,0,0,1-1.72-18.22c2.64-10.38,3.6-8.64.85-14.62s-5.13-7.2-3.49-12.33,4.46-13.15,3.44-18-3.24-6.85-2.24-12.1,4.09-7.78,2.58-13.51-4.15-5.46-3.15-10.72,2.4-5.66,2-10.41.7-7,.7-7,1.81,7.43,3,11.54,1.36,6.48.79,9.48,6.23,8.2,6.43,10.57,1.65,5-.61,10-2.83,8-1.53,11.37,2.71,2.85,1.42,9.61-5.2,6.78-2.3,12,4.64,6.33,3.3,10-3.46,7.9-2.64,10.39a23.24,23.24,0,0,0,1.74,3.57,14.23,14.23,0,0,1,1.57,9.72l-.39,2.05,1.27,10.35-6.17,5.05S59.92,360.71,57.93,354.1Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "60.9909px 300.04px"
    },
    id: "el4qtsga664dr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.81,355a20.08,20.08,0,0,1-5.11-14.69c.64-8.94,1.92-7.66-1.91-12.13s-6.39-5.1-5.75-9.57,1.92-11.49,0-15.32-4.47-5.11-4.47-9.58,2.56-7,0-11.49-5.11-3.83-5.11-8.3,1.28-8.3,0-12.13-.44-3-.44-3,3,6.23,4.91,9.42,2.56,5.11,2.56,7.66,7.66,5.75,8.3,7.66,2.55,3.84,1.27,8.3-1.27,7,.64,9.58,3.19,1.92,3.19,7.66-3.83,6.38,0,10.22,5.75,4.46,5.11,7.66-1.91,7-.64,8.93a15.22,15.22,0,0,0,1.6,1.88,14.7,14.7,0,0,1,4.15,10.21v0l3.19,8.3-5.11,5.11S54,360.1,50.81,355Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "45.0247px 310.047px"
    },
    id: "el0xk4ux1t8sya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2,355a20.1,20.1,0,0,0,5.1-14.69c-.63-8.94-1.91-7.66,1.92-12.13s6.38-5.1,5.75-9.57-1.92-11.49,0-15.32,4.46-5.11,4.46-9.58-2.55-7,0-11.49,5.11-3.83,5.11-8.3-1.28-8.3,0-12.13-.25-1.64-.25-1.64-2.3,4.83-4.22,8-2.55,5.11-2.55,7.66-7.66,5.75-8.3,7.66-2.55,3.84-1.28,8.3,1.28,7-.64,9.58-3.19,1.92-3.19,7.66,3.83,6.38,0,10.22-5.74,4.46-5.1,7.66,1.91,7,.63,8.93a13.85,13.85,0,0,1-1.57,1.85A14.83,14.83,0,0,0,78.9,348h0l-3.19,8.3,5.1,5.11S84,360.1,87.2,355Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "92.8803px 310.468px"
    },
    id: "elgwo9e1sfp96",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.94,356.6a16.2,16.2,0,0,0,2.14-12.36c-1.68-7-2.53-5.85-.07-9.91s4.41-4.91,3.31-8.38-3-8.9-2-12.2,2.89-4.66,2.3-8.22-3-5.25-1.51-9.15,3.56-3.72,3-7.27-2.11-6.44-1.59-9.66-.61-2.38-.61-2.38a60.54,60.54,0,0,1-2.11,8.05c-1.11,2.79-1.36,4.4-1,6.43s-5.34,5.59-5.6,7.19-1.53,3.39.08,6.78,1.94,5.42.75,7.71-2.29,1.94-1.54,6.52,3.89,4.58,1.35,8.13-4,4.32-3.06,6.77,2.45,5.34,1.68,7A37.47,37.47,0,0,1,67.57,347l.84,5.08-1.45,7,4.74,3.39S74.07,361.09,75.94,356.6Z",
    style: {
      fill: "#31A2FB",
      transformOrigin: "75.0819px 319.721px"
    },
    id: "el0f1hheipmw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.67 351.4 93.17 388.84 89.01 388.84 89.01 417.71 46.88 417.71 46.88 388.84 42.99 388.84 41.49 351.4 94.67 351.4",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "68.08px 384.555px"
    },
    id: "el2oiacn2wphb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.76 358.25 41.98 363.67 94.18 363.67 94.39 358.25 41.76 358.25",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "68.075px 360.96px"
    },
    id: "el85uyz7txvbg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.78 373.53 93.92 370.08 42.24 370.08 42.38 373.53 93.78 373.53",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "68.08px 371.805px"
    },
    id: "el2sff8tk0jdx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.99 388.83 41.13 388.83 41.13 458.42 46.88 458.42 46.88 417.71",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "44.005px 423.625px"
    },
    id: "elgy5f4yta2nr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "93.17 388.83 94.75 388.83 94.75 458.42 89.01 458.42 89.01 417.71",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "91.88px 423.625px"
    },
    id: "elh015fu4myti",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-2",
    className: "animable animator-active",
    style: {
      transformOrigin: "268.165px 281.41px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.94,316s-11.32-64.5-11.32-79,14.9-37.5,49.46-46.5,78.66-3,91.77,3.5,20.85,20.5,23.83,43.5S299.62,353,299.62,353l-157.31,2.5Z",
    style: {
      fill: "rgb(102, 102, 102)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "212.62px 270.718px"
    },
    id: "elb7kqs4g1e2s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,440.31a40.34,40.34,0,0,1-11.82,8.87c-7,3.32-10.35,7-10,9.6s4.44,3,11.45,3.33,31.77-.74,35.84-.74,7.38-1.11,7.38-4.44-.74-11.82-.74-11.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "329.733px 451.242px"
    },
    id: "elotwzd9wwdfp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,458.41c-13.06,0-30.61-.75-36.43-1a3.18,3.18,0,0,0-.14,1.38c.37,2.59,4.44,3,11.45,3.33s31.77-.74,35.84-.74c3.66,0,6.72-.91,7.28-3.53C353.08,458.12,347.1,458.41,339,458.41Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "329.704px 459.797px"
    },
    id: "elpjqm2f38nhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.32,278.15s-13.67,56.15-13.67,60.58,12.93,24.75,13.3,40.63-5.54,46.92-4.43,50.24,3,5.54,2.58,8.5-1.47,10.71-1.47,10.71-5.18.37-15.89-1.85A86.61,86.61,0,0,1,322,441.42s-.74-7.76-.74-9.23,1.48-5.18,1.85-8.13-1.11-31.77-4.06-46.91-8.5-34.73-8.5-45.07-.37-46.91-.37-46.91a158.37,158.37,0,0,1,22.53-12.93c13.3-6.28,22.54-2.95,22.54-2.95Z",
    style: {
      fill: "#31A2FB",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "334.75px 358.62px"
    },
    id: "eldhy4leywvbj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.64,270.27a43.1,43.1,0,0,0-4.92,2,167.94,167.94,0,0,0-19.49,10.87l2.42,5.21s26.15,8.4,39.06,6.78l.55-.08c2.28-9.56,4.06-16.87,4.06-16.87l-2.52-5.48a11.72,11.72,0,0,0-3.38-1.45C352,271.05,344.84,270.64,337.64,270.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "336.275px 282.804px"
    },
    id: "elypebi3ad7de",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.86,440.31A40.47,40.47,0,0,1,353,449.18c-7,3.32-10.34,7-10,9.6s4.43,3,11.45,3.33,31.77-.74,35.83-.74,7.39-1.11,7.39-4.44-.74-11.82-.74-11.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "370.323px 451.242px"
    },
    id: "ele2puueqku7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.63,458.41c-13.06,0-30.61-.75-36.43-1a3.18,3.18,0,0,0-.14,1.38c.37,2.59,4.43,3,11.45,3.33s31.77-.74,35.83-.74c3.67,0,6.72-.91,7.29-3.53C393.71,458.12,387.73,458.41,379.63,458.41Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "370.334px 459.797px"
    },
    id: "elxb8zvjn5t5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,278.15s-13.67,56.15-13.67,60.58,12.93,24.75,13.3,40.63-5.54,46.92-4.44,50.24,3,5.54,2.59,8.5-1.48,10.71-1.48,10.71-5.17.37-15.88-1.85a86.61,86.61,0,0,1-17.73-5.54s-.74-7.76-.74-9.23,1.48-5.18,1.85-8.13-1.11-31.77-4.07-46.91-8.49-34.73-8.49-45.07-.37-46.91-.37-46.91a157.66,157.66,0,0,1,22.53-12.93c13.3-6.28,22.53-2.95,22.53-2.95Z",
    style: {
      fill: "#31A2FB",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "375.435px 358.62px"
    },
    id: "elzrc20ynkb3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.73,268.45a38,38,0,0,0-14.38,3.79,157.66,157.66,0,0,0-22.53,12.93s0,4.22.1,10.19c2.35.49,8.84,1.45,21.22.71,13.66-.82,22.21-3.48,24.52-4.28l.72-3,.26-12.75S391.5,271,387.73,268.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "374.23px 282.395px"
    },
    id: "el10hhck89zg9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.46,162.47s-9,2.75-11.25,4.25-5.75,13.25-6.75,16-6.25,17-6.25,17l8.5,1.75s-.25,8.5,1,12,10.25,14,10.25,14l3.25,8.75-3.5,48.5s12.75,6.75,34.25,8.75,36.25,0,38-1a20.18,20.18,0,0,1,3.25-1.5l1.5-7,2.25,6.5a36.44,36.44,0,0,0,8.25-1.75c3-1.25,7.5-3.75,7.5-3.75s-9.25-35-13.25-44.5-10.75-24.25-10.75-24.25-3-34.25-9-45.75-17.25-14.5-25.25-15.25S320.46,162.47,320.46,162.47Z",
    style: {
      fill: "#31A2FB",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "353.46px 224.748px"
    },
    id: "elozjuygdstqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,163.7a68.66,68.66,0,0,0-2.77,17.57",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "316.615px 172.485px"
    },
    id: "el0ae04khi8jt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.44,219a1.25,1.25,0,0,1-.32-.05,10.37,10.37,0,0,1-1.55-.72c-.45.3-.82.52-1,.63a1,1,0,0,1-1-1.72l.28-.17a6.64,6.64,0,0,1-2-3c-1-3.19-1.64-30.09.11-32.89a4.23,4.23,0,0,1,4.6-1.88c1,.27,3.49,1.4,3.72,6.06.29,5.75.64,25.28.3,27.64-.2,1.37-1.7,2.86-3.17,4a2.22,2.22,0,0,0,.34.13,1,1,0,0,1,.63,1.27A1,1,0,0,1,316.44,219ZM314.56,181a2.28,2.28,0,0,0-1.9,1.07c-1.26,2.17-.8,28.22.11,31.26a5,5,0,0,0,1.78,2.42c1.6-1.18,2.95-2.46,3.06-3.2.3-2.09,0-21.09-.32-27.26-.12-2.35-.92-3.89-2.22-4.22A1.79,1.79,0,0,0,314.56,181Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "314.792px 199.039px"
    },
    id: "elsi5xgvent6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.82,216.94l1.75,1.26a8,8,0,0,1-2.41,1.38C311.23,219.77,310.49,219,312.82,216.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "312.919px 218.274px"
    },
    id: "el4ii2451tima",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.42,216.89l-1.85,1.31s1.88,2.5,3.93,1.57S316.42,216.89,316.42,216.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "316.82px 218.434px"
    },
    id: "elngny4plu4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,155.06s-4,20.05-4,35.77",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transformOrigin: "341px 172.945px"
    },
    id: "elto198qlzcao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.58,194.53c0,3.92-2.28,7.1-5.09,7.1s-5.09-3.18-5.09-7.1,2.28-7.09,5.09-7.09S343.58,190.62,343.58,194.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "338.49px 194.535px"
    },
    id: "eldar48ntnpkl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.88,193.61c0,2.49-1.45,4.51-3.24,4.51s-3.24-2-3.24-4.51,1.45-4.51,3.24-4.51S339.88,191.12,339.88,193.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "336.64px 193.61px"
    },
    id: "ellz5b975epca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.29 181.47 381.71 188.97 377.46 181.22 389.29 181.47",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "383.375px 185.095px"
    },
    id: "ely1zswqfnk5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.29,187.8l3,26.33s-43.33,8.34-48,8A31,31,0,0,0,295,224.8c-6.67,3-10,4.67-9.67,6.33s3.33,7,3.33,7,5.67.34,6-.66a8.67,8.67,0,0,0,.34-2.34s6,.34,8.66-1a20.1,20.1,0,0,0,4.67-3.33s35,2.67,48.33,3,28.67-.67,30.34-3-6-50-6-50Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "336.273px 209.493px"
    },
    id: "elxce55fpzjoe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.29,214.13s13.46-4.82,21-1.9",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "369.79px 212.71px"
    },
    id: "elj1xs6aazf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.29 222.13 312.07 231 316.03 231.62 315.19 221.61 311.29 222.13",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "313.66px 226.615px"
    },
    id: "elkqf0nja1s5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.65,221.43c.05.92-1.3,1.75-3,1.85s-3.17-.56-3.23-1.48,1.3-1.75,3-1.85S316.59,220.51,316.65,221.43Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "313.535px 221.615px"
    },
    id: "el622utleey2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.96,
    y1: 235.13,
    x2: 291.42,
    y2: 234.13,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "293.19px 234.63px"
    },
    id: "elnv3762dvv1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.62,172.8l1.67,19,34-10.33S378,161.8,371.62,156.8s-19.33-.67-21,.67",
    style: {
      fill: "#31A2FB",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "369.955px 173.125px"
    },
    id: "elbulwr4xcghf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.71,109.72s-12.25,11.5-7.25,17,12,9,13,15.25,3,10,.25,15.5-4.75,6.75-4.75,6.75,11.75,6,19.25,5.5,18.25-9,18.25-9,17.5-.25,25.25-7,7.5-18.25,4.25-26.25S342.46,110,337,104s-16.25-10-27.5-8.75S288.71,109.72,288.71,109.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "319.68px 132.385px"
    },
    id: "elzus8dmd5m5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,163.22s2.25,5.75,3.75,11,5.5,18.5,5.5,17.75,8-20.75,10-26.5a42.28,42.28,0,0,0,2.25-10.5l-6.75-15.75a38.07,38.07,0,0,1-9,12.5c-6,5.25-7.5,7.75-7.5,7.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "326.875px 165.61px"
    },
    id: "el4rvf4qlvwhr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.12,165.48s10.33-2.91,14.85-6.78,4.84-4.85,4.84-4.85l-5.49-10.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "327.965px 154.5px"
    },
    id: "elrx6a0e5avlp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.21,129.72s4.5,11.25,5.25,14.5,3.5,9.5,7.75,13.25,7,8.75,13.75,7.75,15-13,16.5-16.75-2-14-2-15.25a2,2,0,0,0-1.25-1.75s-12,4.75-20.25,1.25a77.06,77.06,0,0,1-15.5-9.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "312.022px 144.41px"
    },
    id: "elxw5ryl5245",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.46,135.72s3.25-8.5,8-7.5,4.25,9.25,1.75,12.25-4.5,1.5-4.5,1.5",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "330.267px 135.242px"
    },
    id: "elx55w94cy55",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,138a24.69,24.69,0,0,1,.5,4.75c0,2.5-1.25,6.5,1,7.5s5.5,0,6.25-1.25",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "307.875px 144.329px"
    },
    id: "elvw23xzcdnh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.21,154s6.75,1.5,10.5-6.25",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "313.46px 150.933px"
    },
    id: "elabugdyq4d6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.21,139.72a5.9,5.9,0,0,0,7-2.25",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "314.71px 138.786px"
    },
    id: "eltl5tvex81ns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.71,141.47s3.25,1.5,5.25-.75",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "300.335px 141.34px"
    },
    id: "eluabqf4b76cl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.71,136.72s-3.25-2.25-6,.5",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "299.71px 136.537px"
    },
    id: "elcm1o5xmte45",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.21,134.22s1.5-2.5,6.25-2",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "310.335px 133.187px"
    },
    id: "elhsasbyfe5yb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.74,199.58s9,2,12,13.67S289.38,272,289.38,272s15.49,8.85,20.16,9.52,8.66,1,9,6-1,13-3.67,14.33-12.67,1.34-20,1-12-2-16-4.66-8.33-29-13-41.67-14.13-38.91-13.13-45.57S256.41,199.58,259.74,199.58Z",
    style: {
      fill: "#31A2FB",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "285.629px 251.309px"
    },
    id: "elzavvgme0jda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,309l-6.43-.48a18.67,18.67,0,0,0-20.08,18.87l1.2,129.87a3.76,3.76,0,0,0,3.76,3.73h58.82L347.37,308.5Z",
    style: {
      fill: "rgb(51, 51, 51)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "307.929px 384.728px"
    },
    id: "elx8po5gg5gv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.25,461a3.76,3.76,0,0,1-3.76-3.73l-1.2-129.87a18.67,18.67,0,0,1,20.08-18.87l6.43.48a18.69,18.69,0,0,1,17.12,21.09L354,457.7a3.75,3.75,0,0,1-3.72,3.27Z",
    style: {
      fill: "rgb(102, 102, 102)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "349.185px 384.738px"
    },
    id: "el4m9629aw8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.12,338h113a12,12,0,0,1,12,12V461a0,0,0,0,1,0,0h-125a0,0,0,0,1,0,0V338A0,0,0,0,1,196.12,338Z",
    style: {
      fill: "rgb(102, 102, 102)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "258.62px 399.5px"
    },
    id: "elgajoirv6yuk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.62,
    y1: 380.47,
    x2: 203.62,
    y2: 380.47,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "262.62px 380.47px"
    },
    id: "elftxeb2bc06w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.29,290.13l5.33,5.67A101.87,101.87,0,0,1,312,303.13c16.66,7,38,15.34,39.33,25S335,392.13,332,405.47s-3.34,18-3.34,18,3,2.66,2.34,5-4.34,13.66-4.34,13.66a98.72,98.72,0,0,1-16,2.34,82.54,82.54,0,0,1-16.33-1.34s-1-11.33,0-14,4.67-5.66,5-7.66,1.67-33.67,1.67-46,7-32,7-32-33-1.34-42.67-2.34-33-23.33-33.67-34.33S257.29,283.8,273.29,290.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "291.524px 366.428px"
    },
    id: "el3c58u4fxqs2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,438.13s-3-5.66-6.67-3-4.33,6.34-6.33,6.34-19.67-3.34-19.67-3.34-4.67,18.34-3,20.34,17,3.66,23.67,4.66,21.33,4.67,31,4.67,8-7,5.66-9.33-19-11.34-21.33-14.34A22.6,22.6,0,0,1,327,438.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "322.217px 451.109px"
    },
    id: "elgi8u1ff5w3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.38,463.53a58.74,58.74,0,0,1-12.09,1.27c-8.67,0-15.67-3.33-26.67-5.33-8.65-1.58-19.37-4.18-23.54-5.22-.23,2.09-.22,3.7.21,4.22,1.67,2,17,3.66,23.67,4.66s21.33,4.67,31,4.67C351.16,467.8,353.08,465.77,353.38,463.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "322.155px 461.025px"
    },
    id: "el4x0vm0sedwh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.62,196.8s-20,7.67-27.33,12.67-2.67,24-2.67,34.66-2,39.34-2.33,45,7,13.34,12,16.34,47.67,4.66,59,4.66,35.67-7.33,33.67-29-9-38.33-10-42-1.34-15.66-1-19,3-13.33-2-18-26-10-35.67-9.66S204.62,196.8,204.62,196.8Z",
    style: {
      fill: "#31A2FB",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "224.678px 251.292px"
    },
    id: "el2wizfy91f0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.24,218.77a13.32,13.32,0,0,0,2.09,3.78,118.7,118.7,0,0,0,9,10c7.27,7.28,18.71,12.13,18.71,12.13s3.81-20.09,4.5-29.1-4.16-16.28-12.13-19-22.51.34-24.59,5.89C203.3,206.6,205.88,214.94,207.24,218.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "222.98px 220.126px"
    },
    id: "el98nsr4y0k8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.33,190.63a5,5,0,0,0-2,.52,6.67,6.67,0,0,0-3.24,3.63c-1.74,4.16-3.12,8.67-3.12,8.67a104.09,104.09,0,0,0,4.16,15.24A80.5,80.5,0,0,1,208,233.24s12.47-9.36,14.89-11.43a46.32,46.32,0,0,1,7.28-4.51s8.31,4.16,12.12,6.58,6.93,4.51,6.93,4.51a73,73,0,0,0-4.16-20.09c-3.81-10.4-5.54-13.52-7.62-15.59S219.42,184.74,208.33,190.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "224.595px 210.663px"
    },
    id: "elk5cwuiybjk8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,141s2.46-3.15,3.88-.66a20.1,20.1,0,0,0,2.84,3.9s2.83,1.42,3.19,3.9a27.87,27.87,0,0,1,.35,4.61c0,1.06,3.19,1.77,3.19,3.55s-1.77,2.48-2.12,4.25,1.17,3.34-.36,5.67.14,1.48-1.53,2.34-3.43,1.92-3.43,1.92l-8.16-27Z",
    style: {
      fill: "rgb(199, 199, 199)",
      stroke: "rgb(125, 125, 125)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "242.65px 154.931px"
    },
    id: "eleionr7ze034",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.2,128.78s-9.44,2.76-13.38,10.63-4.33,13.78-2.36,20.47,9.44,25.58,11.81,31.09,3.15,15.75,7.87,22,16.14,11.81,16.14,11.81,8.65-11.81,10.23-17.71-1.58-17.71-1.58-17.71,8.66-10.63,7.48-20.86S238.93,144.92,237,141,227.91,124.85,210.2,128.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "219.911px 176.396px"
    },
    id: "elig8p0vsw6fa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,144.55s6.93-3.46,11.43-2.42",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "222.715px 143.243px"
    },
    id: "el95xm033wavg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.22,143.17s6.24-3.12,10.74-3.12",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "219.59px 141.61px"
    },
    id: "el5os447zionp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.93,189.4s-5.31,3.31-10.16,3.31-13.86-3.81-16.63-6.59c0,0,8.21,9.4,16.93,11.75s11.07-1.34,11.07-1.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "226.14px 192.386px"
    },
    id: "elousritzvss7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.52,169a7.64,7.64,0,0,0,.77-.52c1.21-.89,3.39-2.83,3.13-5.15-.35-3.19,0-5-1.77-7.45s-4.61-7.8-4.61-7.8a10,10,0,0,0-6,1.42c-2.48,1.77-1.78,3.19-2.48,5.67s-2.49.71-3.55,4.26.35,5.67,1.77,6.38.36,2.84.36,6a4.88,4.88,0,0,0,4.25,4.61c1.07,0,1.42,1.42,2.84,2.84s6-.17,6-.17,2.15-1.25,2.5-2.67S196.52,169,196.52,169Z",
    style: {
      fill: "rgb(199, 199, 199)",
      stroke: "rgb(125, 125, 125)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "191.04px 163.949px"
    },
    id: "el26lc76eak3z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.58,168.54s-4.73-6.3-7.88-2.76,2.36,12.2,5.51,13.38,7.09-2,7.09-2",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "197.53px 172.062px"
    },
    id: "elmgx68ymuzes",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.31,149.64s-.4,3.55.39,4.73,5.51,3.15,4.72,6.69-5.51,6.69-7.87,3.54",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "229.529px 157.768px"
    },
    id: "elipape6osga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.4,170.9a11.88,11.88,0,0,0,12.6-4.33",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "228.7px 168.941px"
    },
    id: "eldq9i6bhq6w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.6,154.62a1.26,1.26,0,0,1-.33-.05,1,1,0,0,1-.66-1.32c1.76-5.28,8.45-6.18,8.73-6.21a1,1,0,0,1,.26,2.06c-.06,0-5.67.77-7,4.81A1,1,0,0,1,210.6,154.62Z",
    style: {
      fill: "rgb(199, 199, 199)",
      stroke: "rgb(125, 125, 125)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "214.526px 150.826px"
    },
    id: "elr7910yxvjye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.18,148.07a1,1,0,0,1-.73-.3,5.26,5.26,0,0,0-5.89-1,1,1,0,0,1-.93-1.86,7.3,7.3,0,0,1,8.28,1.38,1,1,0,0,1,0,1.47A1,1,0,0,1,236.18,148.07Z",
    style: {
      fill: "rgb(199, 199, 199)",
      stroke: "rgb(125, 125, 125)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "232.644px 146.131px"
    },
    id: "eli2dhao3fr6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.62,159.09a10.24,10.24,0,0,1-4.73,7.09",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "219.255px 162.635px"
    },
    id: "el8fisyocwzzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.82,157.12a15.93,15.93,0,0,0,7.08,2.76",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "237.36px 158.5px"
    },
    id: "el8lr9vx6b244",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,157.81c.35,1.25.06,2.42-.65,2.62s-1.55-.66-1.9-1.91-.06-2.43.65-2.62S218.66,156.56,219,157.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "217.725px 158.166px"
    },
    id: "elnxuyqnpfpp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.69,153.36c.34,1.25.05,2.42-.65,2.62s-1.56-.66-1.9-1.92-.06-2.42.64-2.62S234.34,152.1,234.69,153.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "233.414px 153.71px"
    },
    id: "el8yn1xzxfow",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.17,
    y1: 154.85,
    x2: 214.13,
    y2: 158.21,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "216.65px 156.53px"
    },
    id: "el208pbi32mo6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.16,
    y1: 151.98,
    x2: 236.68,
    y2: 151.74,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "233.92px 151.86px"
    },
    id: "elb13iy5wyb9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.64,293.42s7.4,3.32,8.76,4.28,5.1,6.8,5.41,8.62-.06,2.57-1.2,1.91-4.37-4.53-6.87-7.17-5.69-4.3-6.47-5.87S336.4,293.12,337.64,293.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "344.304px 300.902px"
    },
    id: "elti0kaj18nz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.47,285.5s12.19,4,16.47,5.27a22.92,22.92,0,0,1,8.63,4.93c1.22,1.15,7.95,8.78,8.68,11s1.74,8.16.49,8.71-2.53-.91-3.09-2.17a20.08,20.08,0,0,0-2.26-3.33s1.51,4.81,1.25,7.23-1,3.89-3,4.23-4.24-3-5.79-6.1a21.47,21.47,0,0,0-3.6-5.13l-4.78-2.22a35.22,35.22,0,0,0,3.22,6.89c1.83,2.73,4,3.37,3.21,4.86s-4.43,1.78-6.14-.29-4.46-4.31-6-7.09S317.65,302,317.65,302l-9.76-1.7s-5.71-1.72-6.08-7.74S312.83,283.93,315.47,285.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "326.066px 303.223px"
    },
    id: "elurcqpd7invg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.42,305.05s4.37,5.67,5.81,8.13,1.42,8.21,1.42,8.21",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "339.035px 313.22px"
    },
    id: "eldzzvdyq93ak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.39,
    y1: 309.93,
    x2: 340.5,
    y2: 301.13,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "342.445px 305.53px"
    },
    id: "el2rxdedm39tq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,306.13s22.33-2.66,33.66,1.34,22.34,18,22.34,29.66-2.34,75.67-1.67,77.34,4.33,2,4.33,5.33S273,440.47,273,440.47s-15.67,5.66-21,5.66h-5.34s-7.66-20.33-7.33-23.66,2.33-6,2.33-7.67-9.66-36.67-9.66-47v-23l-18.67-4S205,317.13,217,306.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "243.088px 375.697px"
    },
    id: "elnei22qgk8ko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.62,455.47s-10-11.67-14-18-11.33-10-15.66-6.67-4.34,11.67-4.34,11.67l-7.33-1.34s2.67,9,4,14,3.33,8.34,12,9.67,23,2.33,27-1.67S286.62,455.47,286.62,455.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "267.504px 447.759px"
    },
    id: "elit0efzqwzkq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.29,463.13a3.83,3.83,0,0,0,1.11-4.46,49.42,49.42,0,0,1-5.78,2.8c-7.33,3-17.33,2.33-25.66-.34a20.63,20.63,0,0,1-8.27-4.64c1.37,4.25,3.75,7.1,11.6,8.31C270,466.13,284.29,467.13,288.29,463.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "269.696px 461.231px"
    },
    id: "el83qwvjt380r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.72,287.44s-.66,7.91-.88,10.32,1.1,5.28,2,5.71,1.32-.43,1.32-2.41v-3.3C302.13,297.1,299.72,287.44,299.72,287.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "300.488px 295.509px"
    },
    id: "elb6ifycczp5v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.86,271.21c0-3.44,4.58-10.69,4.58-10.69l1.77-24.3-1.2-4.71-5.34-.38c-2.11,7.08-9.52,32-10.5,35.88a114.57,114.57,0,0,0-2.29,16c0,1.9,0,10.68.77,14.12s6.1,6.86,6.1,6.86,7.2,0,8.34-.76-1.75-3.3-1.75-3.3c-.43,0-1.7-9.42,1-12.34,2.18-2.33,8.4.38,8.4.38s-1.53-4.2-3.44-8S312.86,274.64,312.86,271.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "311.31px 267.56px"
    },
    id: "elubg84pldnjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,303.91s-5.71-3.07-6.37-4.39-.87-11.42-.87-11.42",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "310.38px 296.005px"
    },
    id: "eln8exnq95xgj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.06,303.91s-4.61-4.83-4.61-6.59-1.1-9.22-1.1-9.22",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "305.205px 296.005px"
    },
    id: "elzmg9piqifmc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.84,309l-38.11-.45a18.13,18.13,0,0,0-2.95,0l-6.44.48a18.68,18.68,0,0,0-17.11,21.09l17,127.63a3.76,3.76,0,0,0,3.73,3.27h47.5Z",
    style: {
      fill: "rgb(51, 51, 51)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "168.263px 384.755px"
    },
    id: "elak7b62tmaut",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4,461a3.77,3.77,0,0,0,3.76-3.73l1.2-129.87a18.68,18.68,0,0,0-20.08-18.87l-6.44.48a18.68,18.68,0,0,0-17.11,21.09l17,127.63a3.76,3.76,0,0,0,3.73,3.27Z",
    style: {
      fill: "rgb(102, 102, 102)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "203.464px 384.739px"
    },
    id: "elexfb53yax8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.62,205.8s-14,.33-19.33,8.33-9.67,35.34-10.67,42.34-5.33,31.66-3.66,36.33,6,5.33,14,5.67,11.66-4,13.33-9,6-51.67,6-51.67",
    style: {
      fill: "#31A2FB",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "169.6px 252.144px"
    },
    id: "el3kwsod781yn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,276.13c2,.67,20,5,21.34,8.67a5.1,5.1,0,0,1-1,5.67s-6,14.33-11.34,15.66-17.33-2.33-23.33-5,0-23,.67-24",
    style: {
      fill: "#31A2FB",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "170.031px 291.271px"
    },
    id: "el50xebw6ija4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,294.47s1.33-2-.34-3-4.33-4-7.33-4-8.33,2.66-9.67,8.33-.33,9.67,2,10.33,7.34,2,9.67,2,4-5,4.33-6S192,294.47,192,294.47Z",
    style: {
      fill: "#31A2FB",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "183.281px 297.8px"
    },
    id: "elks3hg2jcvw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.62,296.47s5.67,7,8.34,8.33,5,3,3,5-6.67,1-8.67-1.67S213.62,296.47,213.62,296.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "219.666px 303.663px"
    },
    id: "elt72iofnbbjp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,294.47s15.67-2.34,18-2.34,6,16.67,6.33,19.34,1.67,4.33,0,5.66a4.91,4.91,0,0,1-2.66,1.34,15.28,15.28,0,0,1-3,2c-1,.33-4.67-.34-4.67-.34s-.33,1.34-3,1-11.67-11.66-11.67-11.66-6.66-1.67-9.33-4-1.67-6.34,0-9,5.33-3.34,5.33-3.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "201.041px 306.658px"
    },
    id: "elfou5h9icof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.96,
    y1: 299.8,
    x2: 217.29,
    y2: 317.8,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "213.125px 308.8px"
    },
    id: "elcq684boklsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.62,
    y1: 302.8,
    x2: 212.96,
    y2: 320.47,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "207.79px 311.635px"
    },
    id: "el8mtnjo8ja9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.29,
    y1: 320.13,
    x2: 198.62,
    y2: 306.13,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "203.455px 313.13px"
    },
    id: "el417x62gwvc",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginimg);
export default __webpack_public_path__ + "static/media/loginimg.a40b2cab.svg";
export { ForwardRef as ReactComponent };